function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRakutenAiSymbolFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.833 17.167H9L13.703 30h1.13V17.167zM14.833 14.833V9L2 13.703v1.13h12.833zM17.167 14.833H23L18.293 2h-1.126v12.833zM17.167 17.167V23L30 18.293v-1.126H17.167z",
    fill: props.color
  }));
}

export default SvgIconRakutenAiSymbolFilled;